export default __webpack_public_path__ + "static/media/arrowBottom.4d137372.svg";